const raPolishMessages = {
  ra: {
    action: {
      add_filter: 'Dodaj filtr',
      add: 'Dodaj',
      back: 'Wstecz',
      bulk_actions: 'Wybrano %{smart_count} element |||| Wybrano %{smart_count} elementy',
      cancel: 'Anuluj',
      clear_array_input: 'Wyczyść listę',
      clear_input_value: 'Wyczyść wartość',
      clone: 'Sklonuj',
      confirm: 'Potwierdź',
      create: 'Utwórz',
      create_item: 'Utwórz %{item}',
      delete: 'Usuń',
      edit: 'Edytuj',
      export: 'Eksportuj',
      list: 'Lista',
      refresh: 'Odśwież',
      remove_filter: 'Usuń ten filtr',
      remove_all_filters: 'Usuń wszystkie filtry',
      remove: 'Usuń',
      save: 'Zapisz',
      select_all: 'Zaznacz wszystkie',
      select_all_button: 'Zaznacz wszystkie',
      select_row: 'Zaznacz wiersz',
      show: 'Pokaż',
      sort: 'Sortuj',
      undo: 'Cofnij',
      unselect: 'Odznacz',
      expand: 'Rozwiń',
      close: 'Zamknij',
      open_menu: 'Otwórz menu',
      close_menu: 'Zamknij menu',
      update: 'Aktualizuj',
      move_up: 'Przesuń w górę',
      move_down: 'Przesuń w dół',
      open: 'Otwórz',
      toggle_theme: 'Zmień motyw',
      select_columns: 'Kolumny',
      update_application: 'Aktualizuj aplikację',
    },
    boolean: {
      true: 'Tak',
      false: 'Nie',
      null: '',
    },
    page: {
      create: 'Utwórz %{name}',
      dashboard: 'Panel główny',
      edit: '%{name} %{recordRepresentation}',
      error: 'Coś poszło nie tak',
      list: '%{name}',
      loading: 'Ładowanie',
      not_found: 'Nie znaleziono',
      show: '%{name} %{recordRepresentation}',
      empty: 'Brak %{name}.',
      invite: 'Czy chcesz dodać pierwszy?',
    },
    input: {
      file: {
        upload_several: 'Przeciągnij pliki tutaj lub kliknij, aby wybrać.',
        upload_single: 'Przeciągnij plik tutaj lub kliknij, aby wybrać.',
      },
      image: {
        upload_several: 'Przeciągnij zdjęcia tutaj lub kliknij, aby wybrać.',
        upload_single: 'Przeciągnij zdjęcie tutaj lub kliknij, aby wybrać.',
      },
      references: {
        all_missing: 'Nie można znaleźć powiązanych danych.',
        many_missing: 'Co najmniej jeden powiązany zasób jest niedostępny.',
        single_missing: 'Powiązany zasób jest niedostępny.',
      },
      password: {
        toggle_visible: 'Ukryj hasło',
        toggle_hidden: 'Pokaż hasło',
      },
    },
    message: {
      about: 'O aplikacji',
      are_you_sure: 'Czy na pewno?',
      auth_error: 'Błąd weryfikacji tokenu uwierzytelniającego.',
      bulk_delete_content:
        'Czy na pewno chcesz usunąć %{name}? |||| Czy na pewno chcesz usunąć te %{smart_count} elementy?',
      bulk_delete_title: 'Usuń %{name} |||| Usuń %{smart_count} %{name}',
      bulk_update_content:
        'Czy na pewno chcesz zaktualizować %{name}? |||| Czy na pewno chcesz zaktualizować te %{smart_count} elementy?',
      bulk_update_title: 'Zaktualizuj %{name} |||| Zaktualizuj %{smart_count} %{name}',
      clear_array_input: 'Czy na pewno chcesz wyczyścić całą listę?',
      delete_content: 'Czy na pewno chcesz usunąć ten element?',
      delete_title: 'Usuń %{name} #%{id}',
      details: 'Szczegóły',
      error: 'Wystąpił błąd po stronie klienta i nie można zakończyć żądania.',
      invalid_form: 'Formularz jest nieprawidłowy. Sprawdź błędy.',
      loading: 'Strona się ładuje, chwilę...',
      no: 'Nie',
      not_found: 'Wpisałeś błędny adres URL lub podążyłeś za nieprawidłowym linkiem.',
      yes: 'Tak',
      unsaved_changes: 'Część zmian nie została zapisana. Czy na pewno chcesz je odrzucić?',
    },
    navigation: {
      clear_filters: 'Wyczyść filtry',
      no_filtered_results: 'Brak wyników dla aktualnych filtrów.',
      no_results: 'Brak wyników',
      no_more_results: 'Strona %{page} wykracza poza zakres. Wróć na poprzednią stronę.',
      page_out_of_boundaries: 'Numer strony %{page} poza zakresem',
      page_out_from_end: 'Nie można przejść dalej niż ostatnia strona',
      page_out_from_begin: 'Nie można przejść dalej niż pierwsza strona',
      page_range_info: '%{offsetBegin}-%{offsetEnd} z %{total}',
      partial_page_range_info: '%{offsetBegin}-%{offsetEnd} z więcej niż %{offsetEnd}',
      current_page: 'Strona %{page}',
      page: 'Idź do strony %{page}',
      first: 'Pierwsza strona',
      last: 'Ostatnia strona',
      next: 'Następna',
      previous: 'Poprzednia',
      page_rows_per_page: 'Wierszy na stronę:',
      skip_nav: 'Przejdź do treści',
    },
    sort: {
      sort_by: 'Sortuj po %{field} %{order}',
      ASC: 'rosnąco',
      DESC: 'malejąco',
    },
    auth: {
      auth_check_error: 'Zaloguj się, aby kontynuować',
      user_menu: 'Profil',
      username: 'Login',
      password: 'Hasło',
      sign_in: 'Zaloguj się',
      sign_in_error: 'Logowanie nie powiodło się, spróbuj ponownie',
      logout: 'Wyloguj się',
    },
    notification: {
      updated: 'Element zaktualizowany',
      created: 'Element utworzony',
      deleted: 'Element usunięty',
      bad_item: 'Nieprawidłowy element',
      item_doesnt_exist: 'Element nie istnieje',
      http_error: 'Błąd komunikacji z serwerem',
      data_provider_error: 'Błąd dostawcy danych. Sprawdź konsolę.',
      i18n_error: 'Nie można załadować tłumaczeń dla podanego języka',
      canceled: 'Akcja anulowana',
      logged_out: 'Twoja sesja wygasła, zaloguj się ponownie.',
      not_authorized: 'Brak uprawnień do wykonania tej akcji.',
      application_update_available: 'Dostępna jest nowa wersja.',
    },
    validation: {
      required: 'Wymagane',
      minLength: 'Minimalna długość to %{min}',
      maxLength: 'Maksymalna długość to %{max}',
      minValue: 'Minimalna wartość to %{min}',
      maxValue: 'Wartość musi być %{max} lub mniejsza',
      number: 'Musi być liczbą',
      email: 'Musi być prawidłowym adresem e-mail',
      oneOf: 'Musi być jedną z: %{options}',
      regex: 'Musi pasować do formatu (wyrażenie regularne): %{pattern}',
      unique: 'Musi być unikalne',
    },
    saved_queries: {
      label: 'Zapisane zapytania',
      query_name: 'Nazwa zapytania',
      new_label: 'Zapisz bieżące zapytanie...',
      new_dialog_title: 'Zapisz bieżące zapytanie jako',
      remove_label: 'Usuń zapisane zapytanie',
      remove_label_with_name: 'Usuń zapytanie "%{name}"',
      remove_dialog_title: 'Usunąć zapisane zapytanie?',
      remove_message: 'Czy na pewno chcesz usunąć tę pozycję z listy zapisanych zapytań?',
      help: 'Filtruj listę i zapisz to zapytanie na później',
    },
    configurable: {
      customize: 'Dostosuj',
      configureMode: 'Skonfiguruj tę stronę',
      inspector: {
        title: 'Inspektor',
        content: 'Najedź na elementy interfejsu, aby je skonfigurować',
        reset: 'Resetuj ustawienia',
        hideAll: 'Ukryj wszystkie',
        showAll: 'Pokaż wszystkie',
      },
      Datagrid: {
        title: 'Tabela danych',
        unlabeled: 'Kolumna bez etykiety #%{column}',
      },
      SimpleForm: {
        title: 'Formularz',
        unlabeled: 'Pole bez etykiety #%{tab}',
      },
      SimpleList: {
        title: 'Lista',
        primaryText: 'Tekst główny',
        secondaryText: 'Tekst dodatkowy',
        tertiaryText: 'Tekst trzeciorzędny',
      },
    },
  },
};

export default raPolishMessages;
